import { Box, Flex, FormControl, FormLabel, Select, Text } from "@chakra-ui/react";

const Fieldset = ({ label, description, input, flex, direction, opacity, pointerEvents, riskScore, onScoreChange }) => {
  return (
    <FormControl
      opacity={opacity || 1}
      pointerEvents={pointerEvents || "auto"}
      display={"flex"}
      alignItems={'flex-start'}
      flexDirection={{ lg: direction || "row", base: "column" }}
      gap={{ lg: direction === "row" ? 16 : 8, base: 4 }}
      px={0}
      py={8}
      borderBottom={"1px solid"}
      borderColor={"grey.200"}
      sx={{
        "&:first-of-type": {
          pt: 0,
        },
        "&:last-of-type": {
          borderBottom: "none",
          pb: 0,
        },
      }}
      >
      <Flex direction={"column"} w={{ lg: "40%", base: "100%" }}>
        <FormLabel m={0}>{label}</FormLabel>
        <Text fontSize={"14px"}>{description}</Text>
      </Flex>
      <Flex flex={flex || 1} w={"100%"} gap={4}>
        <Flex flex={1}>{input}</Flex>
        {riskScore && (
          <Box>
            <Select placeholder="Score" onChange={onScoreChange}>
            {[1, 2, 3, 4, 5].map((value) => (
              <option key={value} value={value}>
                {value}
              </option>
            ))}
          </Select>
          </Box>
        )}  
      </Flex>
    </FormControl>
  );
};

export default Fieldset;
